import {put, call, takeLatest} from 'redux-saga/effects';
import {
    getQuicksightEmbeddedUrlRequest,
    getQuicksightEmbeddedUrlSuccess,
    getQuicksightEmbeddedUrlFailed,
} from './actions';


import * as api from '../../../../services/api';

function* getEmbeddedUrlSaga({payload}) {
    const {idDash, extraProperties} = payload;
    try {
        const response = yield call(api.getDashboardsEmbeddedUrl, idDash);
        if (response && response.data) {
            yield put(getQuicksightEmbeddedUrlSuccess({idDash, embedUrl: response.data, extraProperties}));
        } else {
            throw new Error('Dash not Exist');
        }
    } catch (err) {
        yield put(getQuicksightEmbeddedUrlFailed({idDash}));
    }
}

function* embeddedUrlSaga() {
    yield takeLatest(getQuicksightEmbeddedUrlRequest.type, getEmbeddedUrlSaga);
}

export default embeddedUrlSaga;
